import { jsx as f, jsxs as z } from "react/jsx-runtime";
import { useRef as h, useState as d, useLayoutEffect as k, useCallback as a, useMemo as M, cloneElement as G, createElement as J } from "react";
import { selectIconColor as Q } from "./index.es672.js";
import { BaseInput as X } from "./index.es600.js";
import { useOnKeyPress as m } from "@placer-ui/hooks";
import E from "classnames";
import { uniqueId as Y } from "lodash/fp";
import t from "./index.es2380.js";
import { Chip as Z } from "./index.es28.js";
const ee = "chip-input", ue = ({
  testId: C = ee,
  value: r,
  size: F = "default",
  disabled: u,
  required: D,
  onChange: s,
  isError: N,
  LeftIcon: l,
  RightIcon: O,
  placeholder: T,
  ...j
}) => {
  const R = h(null), P = h(null), i = h(null), [o, w] = d(""), [b, V] = d(!1), [n, y] = d(r || []), [x, $] = d(!1), q = h(), S = E(t.root, t[F], {
    [t.disabled]: u,
    [t.required]: D || N,
    [t.focus]: x,
    [t["focus-visible"]]: x
  }), W = E(t.chipContainer, {
    [t.addPadding]: b,
    [t.justChips]: !l && n.length > 0,
    [t.iconALineOfChips]: l && b,
    [t.iconAndChips]: !!l && n.length > 0,
    [t.justIcon]: l && n.length === 0
  }), _ = E(t.inputWrapper, {
    [t.hasChips]: b
  });
  k(() => {
    q.current = n.length - 1;
  }, [n.length]), k(() => {
    r !== void 0 && y(r);
  }, [r]), k(() => {
    var e;
    V(
      (((e = P.current) == null ? void 0 : e.clientHeight) || 0) > 38 && n.length > 0
    );
  }, [n]);
  const A = a(
    (e) => {
      var c;
      y((p) => {
        const B = p.filter((v) => v.label !== e);
        return s == null || s(B), B;
      }), (c = i.current) == null || c.focus();
    },
    [s]
  ), g = a(() => {
    if (o) {
      const e = {
        key: Y(o),
        label: o,
        onDelete: A
      };
      y((c) => {
        const p = [...c, e];
        return s == null || s(p), p;
      }), w("");
    }
  }, [s, o, A]), I = a(() => {
    if (!o && n.length > 0) {
      const e = document.querySelectorAll(
        `[data-testid="chip-value-${n[n.length - 1].label}"]`
      )[0];
      e && e.focus();
    }
  }, [n, o]);
  m("Enter", g, i.current), m("Delete", I, i.current), m("Backspace", I, i.current), m("ArrowLeft", I, i.current);
  const H = a((e) => {
    w(e);
  }, []), K = a(() => {
    $(!0);
  }, []), L = a(() => {
    $(!1);
  }, []), U = M(() => {
    const e = {
      outline: Q("primary-brand", !!u)
    };
    return u ? { ...e, color: "outline", outline: "disabled" } : e;
  }, [u]);
  return /* @__PURE__ */ f(
    "div",
    {
      className: S,
      "data-testid": `${C}-fake-input`,
      onClick: () => {
        var e;
        return (e = i.current) == null ? void 0 : e.focus();
      },
      ref: R,
      children: /* @__PURE__ */ z(
        "div",
        {
          className: W,
          "data-testid": `${C}-chip-container`,
          "aria-label": "chip container",
          role: "status",
          "data-identifier": "chip-container",
          ref: P,
          children: [
            l && /* @__PURE__ */ f(
              "div",
              {
                className: t.leftIcon,
                tabIndex: -1,
                "data-identifier": "chip-input-left-icon",
                children: G(l, U)
              }
            ),
            n.map((e, c) => /* @__PURE__ */ J(
              Z,
              {
                ...e,
                size: "small",
                key: e.key || `${e.label}-${c}`,
                testId: `chip-value-${e.label}`
              }
            )),
            /* @__PURE__ */ f("div", { className: _, children: /* @__PURE__ */ f(
              X,
              {
                ref: i,
                value: o,
                onChange: H,
                RightIcon: O,
                disabled: u,
                isError: N,
                size: (r == null ? void 0 : r.length) !== 0 ? "default" : F,
                testId: C,
                onFocus: K,
                onBlur: L,
                placeholder: T,
                ...j,
                shouldBlurOnEnter: !1,
                disableCloseIcon: !0
              }
            ) })
          ]
        }
      )
    }
  );
};
export {
  ee as CHIP_INPUT_DEFAULT_TESTID,
  ue as ChipInput
};
//# sourceMappingURL=index.es738.js.map
